import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/web/HomeView.vue'
import ArticleList from '../views/web/ArticleListView.vue'
import ArticleListReport from '../views/web/ArticleListReportView.vue'
import ArticleDetail from '../views/web/ArticleDetailView.vue'
import QuestionList from '../views/web/QuestionListView.vue'
import QuestionDetail from '../views/web/QuestionDetailView.vue'
import QuestionAdd from '../views/web/QuestionAddView.vue'
import ComplaintApply from '../views/web/ComplaintApplyView.vue'
import ComplaintApplyMine from '../views/web/ComplaintApplyMine.vue'
import UserLogin from '../views/web/UserLoginView.vue'
import ComplaintApplyDetail from '../views/web/ComplaintApplyDetailMine.vue'
import RobotTalking from '../views/web/RobotTalkingVue.vue'


//管理系统
import ArticleAdd from '../views/admin/ArticleAddView.vue'
import ArticleAll from '../views/admin/ArticleAllView.vue'
import ArticleEdit from '../views/admin/ArticleEditView.vue'
import QuestionAll from '../views/admin/QuestionAllView.vue'
import QuestionCheck from '../views/admin/QuestionCheckView.vue'
import ComplaintApplyAll from '../views/admin/ComplaintApplyAll.vue'
import ComplaintApplyReply from '../views/admin/ComplaintApplyReply.vue'
import AnswerAll from '../views/admin/AnswerAllView.vue'
import KeywordAll from '../views/admin/KeywordAllView.vue'
import KeywordAdd from '../views/admin/KeywordAddView.vue'
import KeywordEdit from '../views/admin/KeywordEditView.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/article/list',
    name: 'ArticleList',
    component: ArticleList
  },
  {
    path: '/article/list/report',
    name: 'ArticleListReport',
    component: ArticleListReport
  },
  {
    path: '/article/show',
    name: 'ArticleDetail',
    component: ArticleDetail
  },
  {
    path: '/question/list',
    name: 'QuestionList',
    component: QuestionList
  },
  {
    path: '/question/show',
    name: 'QuestionDetail',
    component: QuestionDetail
  },
  {
    path: '/question/add',
    name: 'QuestionAdd',
    component: QuestionAdd
  },
  {
    path: '/complaint/apply/add',
    name: 'ComplaintApply',
    component: ComplaintApply
  },
  {
    path: '/complaint/apply/mine',
    name: 'ComplaintApplyMine',
    component: ComplaintApplyMine
  },
  {
    path: '/complaint/apply/detail',
    name: 'ComplaintApplyDetail',
    component: ComplaintApplyDetail
  },
  {
    path: '/user/login',
    name: 'UserLogin',
    component: UserLogin
  },
  {
    path: '/robot/talking',
    name: 'RobotTalking',
    component: RobotTalking
  },
  

  

  //管理
  {
    path: '/admin/article/add',
    name: 'ArticleAdd',
    component: ArticleAdd
  },
  {
    path: '/admin/article/all',
    name: 'ArticleAll',
    component: ArticleAll
  },
  {
    path: '/admin/article/edit',
    name: 'ArticleEdit',
    component: ArticleEdit
  },
  {
    path: '/admin/question/all',
    name: 'QuestionAll',
    component: QuestionAll
  },
  {
    path: '/admin/question/check',
    name: 'QuestionCheck',
    component: QuestionCheck
  },
  {
    path: '/admin/answer/all',
    name: 'AnswerAll',
    component: AnswerAll
  },
  {
    path: '/admin/complaint/apply/all',
    name: 'ComplaintApplyAll',
    component: ComplaintApplyAll
  },
  {
    path: '/admin/complaint/apply/reply',
    name: 'ComplaintApplyReply',
    component: ComplaintApplyReply
  },
  {
    path: '/admin/keyword/all',
    name: 'KeywordAll',
    component: KeywordAll
  },
  {
    path: '/admin/keyword/add',
    name: 'KeywordAdd',
    component: KeywordAdd
  },
  {
    path: '/admin/keyword/edit',
    name: 'KeywordEdit',
    component: KeywordEdit
  }
  





]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
